import React from "react";
import { DateFilters } from "../../../../../components/ui/Form/Period";
import _Button from "../../../../../components/generic/_Button";
import _Select from "../../../../../components/generic/_Select";
import DataReportErrorsByPartners from "./DataReportErrorsByPartners";
import { useRCSReportErrorsByPartners } from "../hooks/useRCSReportErrorsByPartners";
import { useFetchPartnersByCustomers } from "../hooks/useFetchPartnersByCustomers";
const ReportErrorsByPartner = () => {
  const { formik, isLoading, _validate, handleReset, data } =
    useRCSReportErrorsByPartners();
  const { data: partners = [] } = useFetchPartnersByCustomers();
  return (
    <div className="flex flex-col">
      <div className="bg-white rounded-lg p-3">
        <div className="w-full flex justify-between gap-2">
          <DateFilters
            required
            setFilterFrom={(e) => formik.setFieldValue("period.dateFrom", e)}
            setFilterTo={(e) => formik.setFieldValue("period.dateTo", e)}
            errors={formik.errors}
            isClean={formik.values.period.dateFrom === ""}
          />
          <_Select
            required
            title="Partner asociados"
            onChange={(e) => {
              formik.setFieldValue("partner", e.target.value)
            }}
            value={formik.values.partner}
            options={[
              {
                value: "",
                label: "Selecciona un partner",
              },
              ...partners.map((item) => {
                return {
                  value: item.uidpartner,
                  label: item.name,
                };
              }),
            ]}
          />
        </div>
        <div className="gap-2 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2">
          <_Button
            icon="clear_all"
            onClick={handleReset}
            disabled={isLoading}
            loading={isLoading}
            style="none"
            title="Limpiar"
            className="w-full"
          />
          <_Button
            icon="analytics"
            style="primary"
            onClick={async () => await _validate()}
            title="Generar Reporte"
            className="w-full"
          />
        </div>
        <DataReportErrorsByPartners data={data} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default ReportErrorsByPartner;
